"use client"

import { Breadcrumbs, BackToTopButton } from "@/components/atoms"
import React from "react"

export function CategoriesPageClient({
  breadcrumbsItems,
  translations,
  children
}: {
  breadcrumbsItems: { path: string; label: string }[]
  translations: { all_products: string }
  children: React.ReactNode
}) {
  return (
    <main className="container">
      <div className="hidden md:block mb-2">
        <Breadcrumbs items={breadcrumbsItems} />
      </div>

      <h1 className="heading-lg uppercase text-[#0B0F0E]">{translations.all_products}</h1>

      {children}

      <BackToTopButton />
    </main>
  )
}